import useFetch from './useFetch';

export default function useLocation() {
  const {
    data: { data: location, meta },
  } = useFetch('/api/v2/services/location');

  return { location, discount: meta?.discount };
}
